<template><section><template>
<h3>普通输入框</h3>
<div class="bs-docs-section">
<div class="bs-example">
<p><n3-input v-model="value" ref="input" show-clean=""></n3-input>
<n3-button @click.native="$refs.input.focus()">聚焦</n3-button></p>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-input</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"input"</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"archive"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-input</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"$refs.input.focus()"</span>&gt;</span>聚焦<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
</code></pre>
<h3>密码输入框</h3>
<p><n3-input v-model="value2" type="password" ref="input2" show-clean=""></n3-input>
<n3-button @click.native="$refs.input2.focus()">聚焦</n3-button></p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-input</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value2"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"password"</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"archive"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-input</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"$refs.input2.focus()"</span>&gt;</span>聚焦<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td><code v-pre="">String</code></td>
<td>－</td>
<td></td>
</tr>
<tr>
<td>readonly</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>只读</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>禁止改变值</td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">220px</code></td>
<td>宽度</td>
</tr>
<tr>
<td>placeholder</td>
<td><code v-pre="">String</code></td>
<td>－</td>
<td>placeholder</td>
</tr>
<tr>
<td>type</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">text</code></td>
<td>输入框类型</td>
</tr>
<tr>
<td>icon</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td>icon</td>
</tr>
<tr>
<td>show-clean</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>显示清除icon</td>
</tr>
</tbody>
</table>
<h3>组件方法</h3>
<table>
<thead>
<tr>
<th>方法名称</th>
<th>说明</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>clean</td>
<td>清空内容</td>
<td></td>
</tr>
<tr>
<td>focus</td>
<td>聚焦</td>
<td></td>
</tr>
<tr>
<td>blur</td>
<td>失焦</td>
<td></td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>blur</td>
<td>失焦</td>
<td>-</td>
</tr>
<tr>
<td>focus</td>
<td>聚焦</td>
<td>-</td>
</tr>
<tr>
<td>change</td>
<td>值变化</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
 <p>其他表单相关参数，请移步 <a href="#n3FormDocs">表单验证</a> 待验证组件参数</p>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      value: '',
      value2: ''
    }
  },
  mounted () {
    this.value = 100
  }
}
</script>


// WEBPACK FOOTER //
// n3InputDocs.md?3079c244